/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `video_title` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class VideoTitleMesg : Mesg {
    public constructor() : super("VideoTitle", Profile.MesgNum.VIDEO_TITLE)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. Long titles will be split into multiple parts */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** message_count. Total number of title parts */
    public var messageCount: UShort?
        get() = getFieldValue(MESSAGE_COUNT_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_COUNT_FIELD_NUM, value)

    /** text. */
    public var text: String?
        get() = getFieldValue(TEXT_FIELD_NUM) as? String
        set(value) = setFieldValue(TEXT_FIELD_NUM, value)

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val MESSAGE_COUNT_FIELD_NUM: UByte = 0u
        public const val TEXT_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("MessageCount", 0u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[1] = Field("Text", 1u, BaseType.STRING, 1.0, 0.0, "", false)
            return fields
        }
    }
}
